module.exports = __webpack_public_path__ + "img/discount-circle-red.2aed8f61.svg";